export default "__VITE_ASSET__BONncKMF__"